import { FilterConfig } from "../../components/DataTable/TableFiltersElement";

export const seedMachineNameFilter = (filters: FilterConfig[], machineName: string | null): FilterConfig[] => {
  if (!machineName) return filters;
  if (!filters.some(f => f.key === "MachineName")) return filters;

  return filters.map(f => f.key === "MachineName" ? { ...f, value: machineName } : f);
};

const sameOptions = (a: string[] | undefined, b: string[]) =>
  !!a && a.length === b.length && a.every((value, i) => value === b[i]);

/**
 * Fills the Status dropdown's options once the stoppage types have loaded, without disturbing
 * what is already filtered, so neither a user's typing nor a value seeded from a link is lost.
 */
export const withStatusOptions = (filters: FilterConfig[], statusOptions: string[]): FilterConfig[] => {
  const status = filters.find(f => f.key === "Status");
  if (!status || sameOptions(status.possibleValues, statusOptions)) return filters;

  return filters.map(f => f.key === "Status" ? { ...f, possibleValues: statusOptions } : f);
};
